import Swiper from 'swiper/js/swiper';

import backToTopBtn from './scroller/_back-to-top';

import { IS_IE } from '../_consts';

export default () => {
  const autoHeight = !IS_IE;

  const updateScroller = () => {
    if(IS_IE) return;
    setTimeout(() => {
      window.SCROLLER.scroll.update();
      backToTopBtn.recountValues();
    }, 400) 
  };

  // eslint-disable-next-line
  const slider = new Swiper('.js-home-slider', {
    loop: false,
    speed: 500,
    autoHeight,
    pagination: {
      el: '.js-swiper-pagination',
      clickable: true
    },
    on: {
      init: () => {updateScroller()},
      transitionEnd: () => {updateScroller()},
    },
    navigation: {
      nextEl: '.js-swiper-next',
      prevEl: '.js-swiper-prev',
    },
  });
};
